export { default, IPopoverProps } from "./Tooltip"
